import { useEffect } from 'react';

export const useRoving = (ref, x) => {
  useEffect(() => {
    const currentRef = ref.current;

    if (!currentRef) {
      return;
    }

    const onKeyDownHandler = (e) => {
      const links = [...currentRef.querySelectorAll('[role="menuitem"]')];
      const index = links.indexOf(document.activeElement);
      const firstIndex = 0;
      const lastIndex = links.length - 1;

      const focusFirst = () => links[firstIndex].focus();
      const focusLast = () => links[lastIndex].focus();
      const focusNext = () => links[index + 1].focus();
      const focusBack = () => links[index - 1].focus();

      if (x ? e.key === 'ArrowLeft' : e.key === 'ArrowUp') {
        e.preventDefault();

        if (index !== firstIndex) {
          focusBack();
        } else {
          focusLast();
        }
      } else if (x ? e.key === 'ArrowRight' : e.key === 'ArrowDown') {
        e.preventDefault();

        if (index !== lastIndex) {
          focusNext();
        } else {
          focusFirst();
        }
      } else if (e.key === 'Home') {
        focusFirst();
      } else if (e.key === 'End') {
        focusLast();
      }
    };

    document.addEventListener('keydown', onKeyDownHandler);

    return () => {
      document.removeEventListener('keydown', onKeyDownHandler);
    };
  });
};
